import { createComponent } from '@carvana/merch-components';

export const InnerWrapper = createComponent('div', {
  className: 'flex h-full flex-col items-start gap-8'
});

export const CardWrapper = createComponent('div', {
  className:
    'flex h-full w-full flex-col rounded-md border border-grey-2 bg-white p-24'
});

export const ImageWrapper = createComponent('div', {
  className: 'flex items-center py-4'
});

export const ListItem = createComponent('li', {
  className:
    'flex break-inside-avoid-column gap-8 text-grey-5 tl-body-m before:list-none'
});
